module.exports = __webpack_public_path__ + "img/album.e2cc38f3.png";